import React, { useEffect } from 'react';
import { Link, useParams, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import PageTitle from '../../FormElements/PageTitle';

export default function PropertyPOAPage() {
	const { id } = useParams();
	const location = useLocation();

	// Access the state passed from the Link in PropertyBasicDetailsCard
	const propertyName = location.state ? location.state.propertyName : '';

	useEffect(
		() => {
			// Log the propertyName to verify it's received correctly
			console.log('Received propertyName:', propertyName);
		},
		[
			id,
			propertyName
		]
	);

	return (
		<div>
			<div className="-mt-8 md:-mt-12 mb-8 md:mb-12 md:text-xl">
				<Link to="/dashboard" className="hover:underline mr-2 md:mr-3">
					Dashboard
				</Link>
				<i
					className="text-gray-400 fa fa-chevron-right text-xs md:text-base mr-2 md:mr-3"
					aria-hidden="true"
				/>
				<Link to={`/properties/${id}`} className="hover:underline mr-2 md:mr-3">
					{propertyName || 'Property Name'}
				</Link>
				<i
					className="text-gray-400 fa fa-chevron-right text-xs md:text-base mr-2 md:mr-3"
					aria-hidden="true"
				/>
			</div>
			<PageTitle title="Sign POA" />

			<iframe
				src="https://esignatures.io/sign/24cd44a8-8958-4df3-830c-a88eddb47477"
				id="eSignaturesIOIframe"
				onLoad="iFrameResize({heightCalculationMethod: 'bodyScroll'}, '#eSignaturesIOIframe')"
				style={{ width: '100%', minWidth: '100%', height: '1600px' }}
			/>
		</div>
	);
}
